import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="adminlte"
export default class extends Controller {
  connect() {
    const sidebarToggle = document.querySelector('[data-lte-toggle="sidebar"]');
    if (sidebarToggle) {
      sidebarToggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.pushMenu = new window.adminlte.PushMenu(sidebarToggle);
        this.pushMenu.toggle();
      });
      const sidebarElement = document.querySelector('.app-sidebar');
      if (sidebarElement) {
        this.pushMenu = new window.adminlte.PushMenu(sidebarElement);
        this.pushMenu.init();
      }
    }

    const layout = new window.adminlte.Layout(document.body);
    layout.holdTransition();

    this.initTreeview();
    this.initSidebarOverlay();

    setTimeout(() => {
      document.body.classList.add('app-loaded');
    }, 400);
  }

  initTreeview() {
    const openMenuItems = document.querySelectorAll(".nav-item.menu-open");
    openMenuItems.forEach(menuItem => {
      const childElement = menuItem.querySelector(".nav-treeview");
      if (childElement) {
        window.adminlte.slideDown(childElement, 0);
        const event = new Event("load.lte.treeview");
        menuItem.dispatchEvent(event);
      }
    });
    const button = document.querySelectorAll('[data-lte-toggle="treeview"]');

    const Default = {
        animationSpeed: 300,
        accordion: true
    };

    button.forEach(btn => {
      btn.addEventListener('click', event => {
        const target = event.target;
        const targetItem = target.closest(".nav-item");
        const targetLink = target.closest(".nav-link");
        const lteToggleElement = event.currentTarget;
        if (target?.getAttribute('href') === '#' || targetLink?.getAttribute('href') === '#') {
          event.preventDefault();
        }
        if (targetItem) {
          // Read data attributes
          const accordionAttr = lteToggleElement.dataset.accordion;
          const animationSpeedAttr = lteToggleElement.dataset.animationSpeed;
          // Build config from data attributes, fallback to Default
          const config = {
            accordion: accordionAttr === undefined ? Default.accordion : accordionAttr === 'true',
            animationSpeed: animationSpeedAttr === undefined ? Default.animationSpeed : Number(animationSpeedAttr)
          };
          const data = new window.adminlte.Treeview(targetItem, config);
          data.toggle();
        }
      });
    });
  }

  initSidebarOverlay() {
    // Crie overlay se não existir
    let sidebarOverlay = document.querySelector('.sidebar-overlay');
    if (!sidebarOverlay) {
      sidebarOverlay = document.createElement('div');
      sidebarOverlay.className = 'sidebar-overlay';
      const appWrapper = document.querySelector('.app-wrapper');
      if (appWrapper) {
        appWrapper.append(sidebarOverlay);
      } else {
        document.body.append(sidebarOverlay);  // Fallback
      }
    }

    // Flag para touch move (evita fechar se o usuário scrollou no overlay)
    let overlayTouchMoved = false;

    // Evento para touchstart (inicia tracking)
    sidebarOverlay.addEventListener('touchstart', () => {
      overlayTouchMoved = false;
    }, { passive: true });

    // Evento para touchmove (detecta scroll/gesto)
    sidebarOverlay.addEventListener('touchmove', () => {
      overlayTouchMoved = true;
    }, { passive: true });

    // Evento para touchend (fecha só se não moveu)
    sidebarOverlay.addEventListener('touchend', (e) => {
      if (!overlayTouchMoved) {
        e.preventDefault();
        this.closeSidebar();
      }
      overlayTouchMoved = false;
    }, { passive: false });

    // Evento para clique (desktop/mobile)
    sidebarOverlay.addEventListener('click', (e) => {
      e.preventDefault();
      this.closeSidebar();
    });

    // Método helper para fechar (usa collapse para animação suave)
    this.closeSidebar = () => {
      if (this.pushMenu && document.body.classList.contains('sidebar-open')) {
        this.pushMenu.collapse();
      }
    };
  }
}